import axios from "axios";
// const pdfjsLib = require("pdfjs-dist/build/pdf.js");
// const pdfjsWorker = require("pdfjs-dist/build/pdf.worker.entry");

async function PdfToImageConverter(URL) {
//   const pdfData = await axios.get(URL, { responseType: 'arraybuffer' });
//   const pdf = await pdfjsLib.getDocument(new Uint8Array(pdfData.data)).promise;
//   const imagesList = [];
//   const canvas = document.createElement("canvas");
//   canvas.classList.add("canv");  // Use classList.add to add a class
//   let canv = document.querySelector(".canv");

//   for (let i = 1; i <= pdf.numPages; i++) {
//       var page = await pdf.getPage(i);
//       var viewport = page.getViewport({ scale: 2 });
//       canvas.height = viewport.height;
//       canvas.width = viewport.width;
//       var render_context = {
//           canvasContext: canvas.getContext("2d"),
//           viewport: viewport
//       };
//       await page.render(render_context).promise;
//       let img = canvas.toDataURL("image/png");
//       imagesList.push(img);
//   }

//     return imagesList;
return []
}

export default PdfToImageConverter;
